import { useState, useEffect } from 'react';

export const useRecaptcha = () => {
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [recaptchaReady, setRecaptchaReady] = useState(false);
  const siteKey = '6LdahTUqAAAAAGTJkeuKQRw7kOr2ux3DON8EwuxF'; // 正しいサイトキーを使用

  const executeRecaptcha = () => {
    if (window.grecaptcha) {
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(siteKey, { action: 'submit' })
          .then(token => {
            setRecaptchaToken(token);
            setRecaptchaReady(true);
          })
          .catch(err => {
            console.error('Error executing reCAPTCHA:', err);
            // リトライのために遅延を設けて再試行
            setTimeout(executeRecaptcha, 3000);
          });
      });
    } else {
      console.error('grecaptcha object is not available.');
    }
  };

  useEffect(() => {
    if (window.grecaptcha) {
      executeRecaptcha();
    } else {
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
      script.async = true;
      script.defer = true;
      script.onload = executeRecaptcha;
      script.onerror = () => {
        console.error('Failed to load reCAPTCHA script.');
      };
      document.body.appendChild(script);
    }
  }, []);

  // トークンの手動リフレッシュを可能にする
  const refreshRecaptchaToken = () => {
    setRecaptchaToken(null);
    setRecaptchaReady(false);
    executeRecaptcha();
  };

  return [recaptchaToken, recaptchaReady, refreshRecaptchaToken];
};

